export default "__VITE_ASSET__QvM90ls0__"